import type { ThemeOptions } from '@mui/material/styles';

import { fontFamilies } from 'src/design-tokens/primitives';

export const TYPE_SCALE = {
  xs: { fontSize: '0.75rem', lineHeight: '1rem', letterSpacing: 0 },
  sm: { fontSize: '0.875rem', lineHeight: '1.25rem', letterSpacing: 0 },
  md: { fontSize: '1rem', lineHeight: '1.5rem', letterSpacing: 0 },
  lg: { fontSize: '1.125rem', lineHeight: '1.75rem', letterSpacing: 0 },
  xl: { fontSize: '1.25rem', lineHeight: '1.75rem', letterSpacing: 0 },
  '2xl': { fontSize: '1.5rem', lineHeight: '2rem', letterSpacing: 0 },
  '3xl': { fontSize: '1.875rem', lineHeight: '2.25rem', letterSpacing: 0 },
} as const;

export const FONT_WEIGHT = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
} as const;

export const BUTTON_TYPE = {
  large: { ...TYPE_SCALE.md, fontWeight: FONT_WEIGHT.semiBold },
  medium: { ...TYPE_SCALE.sm, fontWeight: FONT_WEIGHT.semiBold },
  small: { ...TYPE_SCALE.xs, fontWeight: FONT_WEIGHT.semiBold },
} as const;

export const typography: ThemeOptions['typography'] = {
  fontFamily: fontFamilies.sans.join(', '),
  h1: { ...TYPE_SCALE['3xl'], fontWeight: FONT_WEIGHT.extraBold },
  h2: { ...TYPE_SCALE['2xl'], fontWeight: FONT_WEIGHT.extraBold },
  h3: { ...TYPE_SCALE.xl, fontWeight: FONT_WEIGHT.extraBold },
  h4: { ...TYPE_SCALE.lg, fontWeight: FONT_WEIGHT.extraBold },
  h5: { ...TYPE_SCALE.md, fontWeight: FONT_WEIGHT.extraBold },
  h6: { ...TYPE_SCALE.sm, fontWeight: FONT_WEIGHT.extraBold },
  subtitle1: { ...TYPE_SCALE.md, fontWeight: FONT_WEIGHT.semiBold },
  subtitle2: { ...TYPE_SCALE.sm, fontWeight: FONT_WEIGHT.semiBold },
  body1: { ...TYPE_SCALE.md, fontWeight: FONT_WEIGHT.regular },
  body2: { ...TYPE_SCALE.sm, fontWeight: FONT_WEIGHT.regular },
  caption: { ...TYPE_SCALE.xs, fontWeight: FONT_WEIGHT.medium },
  buttonLarge: BUTTON_TYPE.large,
  buttonMedium: BUTTON_TYPE.medium,
  buttonSmall: BUTTON_TYPE.small,
  button: {
    ...BUTTON_TYPE.medium,
    textTransform: 'none',
  },
};
